import React from "react";
import { Fragment } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navigation = [
	{ name: "Home", href: "/", current: true },
	{ name: "About", href: "/About", current: true },
];

function classNames(...classes) {
	return classes.filter(Boolean).join(" ");
}

const Navbar = () => {
	let location = useLocation();

	let navigate = useNavigate();

	const handleSignOut = () => {
		localStorage.removeItem("auth-token");
		navigate("/Login");
	};

	return (
		<Disclosure as="nav" className="bg-gray-800 fixed w-full top-0">
			{({ open }) => (
				<>
					<div className="max-w-full mx-auto px-2 sm:px-7 lg:px-5">
						<div className="relative flex items-center justify-between h-14">
							<div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
								{/* Mobile menubutton*/}
								<Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
									<span className="sr-only">Open main menu</span>
									{open ? (
										<XIcon className="block h-6 w-6" aria-hidden="true" />
									) : (
										<MenuIcon className="block h-6 w-6" aria-hidden="true" />
									)}
								</Disclosure.Button>
							</div>
							<div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
								{/* Navbar-name */}
								<div className="flex-shrink-0 flex items-center">
									<div className="block h-8 w-auto text-white">
										<a href="/">myNotes</a>
									</div>
								</div>
								<div className="hidden sm:block sm:ml-6">
									<div className="flex space-x-4">
										{navigation.map((item) => (
											<Link
												key={item.name}
												to={item.href}
												className={`px-3 py-2 rounded-md text-sm font-medium ${
													location.pathname === `${item.href}`
														? "bg-gray-900 text-white"
														: "text-gray-300 hover:bg-gray-700 hover:text-white"
												}`}
											>
												{item.name}
											</Link>
										))}
									</div>
								</div>
							</div>
							<div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
								{/* Profile dropdown */}
								<Menu as="div" className="ml-3 relative">
									<div>
										<Menu.Button className="bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
											<span className="sr-only">Open user menu</span>
											<div
												className="h-8 w-8 rounded-full bg-[#94a3b8]"
												alt=""
											/>
										</Menu.Button>
									</div>
									<Transition
										as={Fragment}
										enter="transition ease-out duration-100"
										enterFrom="transform opacity-0 scale-95"
										enterTo="transform opacity-100 scale-100"
										leave="transition ease-in duration-75"
										leaveFrom="transform opacity-100 scale-100"
										leaveTo="transform opacity-0 scale-95"
									>
										<Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
											<Menu.Item>
												{({ active }) => (
													<a
														href="/"
														className={classNames(
															active ? "bg-gray-100" : "",
															"block px-4 py-2 text-sm text-gray-700"
														)}
													>
														Your Profile
													</a>
												)}
											</Menu.Item>
											{localStorage.getItem("auth-token") ? (
												<Menu.Item>
													{({ active }) => (
														<a
															href="/Login"
															className={classNames(
																active ? "bg-gray-100" : "",
																"block px-4 py-2 text-sm text-gray-700"
															)}
															onClick={handleSignOut}
														>
															Sign out
														</a>
													)}
												</Menu.Item>
											) : (
												<Menu.Item>
													{({ active }) => (
														<Link
															to="/Login"
															className={classNames(
																active ? "bg-gray-100" : "",
																"block px-4 py-2 text-sm text-gray-700"
															)}
														>
															Log in
														</Link>
													)}
												</Menu.Item>
											)}
											<Menu.Item>
												{({ active }) => (
													<Link
														to="/Signup"
														className={classNames(
															active ? "bg-gray-100" : "",
															"block px-4 py-2 text-sm text-gray-700"
														)}
													>
														Sign up
													</Link>
												)}
											</Menu.Item>
										</Menu.Items>
									</Transition>
								</Menu>
							</div>
						</div>
					</div>

					{/* Dropdown for mobile */}
					<Disclosure.Panel className="sm:hidden">
						<div className="px-2 pt-2 pb-3 space-y-1">
							{navigation.map((item) => (
								<Disclosure.Button
									key={item.name}
									as="a"
									className={`block px-3 py-2 rounded-md text-base font-medium
										${
											location.pathname === `${item.href}`
												? "bg-gray-900 text-white"
												: "text-gray-300 hover:bg-gray-700 hover:text-white"
										}`}
									aria-current={item.current ? "page" : undefined}
								>
									<Link to={item.href} className="w-full">
										{item.name}
									</Link>
								</Disclosure.Button>
							))}
						</div>
					</Disclosure.Panel>
				</>
			)}
		</Disclosure>
	);
};

export default Navbar;
